// look inside box event
let lookInisideBox = document.getElementById("lookInsideBox__js");
let lookInisideBoxProductDetails = document.querySelector(
  ".lookInisideBoxProducDetails__js"
);
let lookInisideBoxButton = document.querySelector(
  "#lookInsideBox__js button.btn"
);
let lookInisideBoxPill = document.querySelectorAll(".lookInsideBoxPill__js");

if (lookInisideBox && lookInisideBoxPill) {
  document.querySelector("#MainContent").classList.add("overflow-hidden");
  lookInisideBoxPill.forEach((pill) => {
    pill.addEventListener(
      "click",
      debounce(function () {
        lookInisideBox.scrollIntoView();
      }),
      100
    );
  });
}

if (lookInisideBoxButton && lookInisideBoxProductDetails) {
  lookInisideBoxButton.addEventListener(
    "click",
    debounce(function (e) {
      body.scrollIntoView();
      e.stopImmediatePropagation();
    }),
    100
  );
}
